<template>
  <div class="tender-agency">
    <div class="calc-rules">
      <h4>基准计算规则</h4>
      <div class="calc-rules-value">
        <h6>引用费率文件</h6>
         <div v-for="item in fileList" :key="item.id" class="calc-rules-file">
          <div class="calc-rules-file-name">{{ item.fileName }}</div>
          <t-button theme="default" variant="outline" @click="fileOpen(item.url)">文件查看
            <img src="@/assets/icon/Vector.svg" style="width: 4px;height: 7px;left: 4px;top: 8px;position: relative;">
          </t-button>
        </div>
      </div>
    </div>
    <div style="height: 20px;background-color: #f5f5f5;"></div>

    <div class="calc-templete">
      <h6>设计招标代理收费计算模版</h6>
      <t-form :data="formData" :rules="rules" ref="form" @reset="onReset" @submit="onSubmit" labelWidth="200px">

        <t-form-item label="工程名称" name="projectName">
          <t-input v-model="formData.projectName" placeholder="请输入工程名称" style="width: 320px;"></t-input>
        </t-form-item>

        <t-form-item label="工程造价" name="money">
          <t-input-number v-model="formData.money" placeholder="请输入工程造价" style="width: 320px;" suffix="万元（中标价）" :min="0" theme="normal"></t-input-number>
        </t-form-item>
        <t-form-item label="小计(收费区间值)" name="subtotal">
          <t-input v-model="formData.subtotal" placeholder="" disabled style="width: 320px;"></t-input>
        </t-form-item>
        <t-form-item label="让利(折扣率)" name="discountRate">
          <t-input v-model="discountRate" style="width: 87px;" placeholder="" label="-" suffix="%"></t-input>
          <t-input v-model="formData.discountRateMoney" placeholder="" disabled
            style="width: 217px;margin-left: 16px;"></t-input>
        </t-form-item>
        <t-form-item label="招标代理收费合计(万元)" name="result">
          <t-input v-model="formData.result" placeholder="" disabled style="width: 320px;"
            @change="resultChange"></t-input>
        </t-form-item>
        <t-form-item label="金额大写" name="resultChinese">
          <t-input v-model="resultChinese" placeholder="" disabled style="width: 320px;"></t-input>
        </t-form-item>




        <t-form-item style="margin-left: 140px">
          <t-row>
            <t-col :span=12>
              <t-space size="10px">
                <t-button theme="primary" type="submit" class="submit" >提交结果</t-button>
                <t-button class="download" @click="downLoad" :disabled="!formData.result" :loading="downLoading">下载结果</t-button>

              </t-space>
            </t-col>
            <t-col :span=12 style="margin-top: 10px;">
              <t-button theme="default" variant="base" @click="handleClear" class="help">是否需要详细过程？给点小费求助·</t-button>
            </t-col>
          </t-row>



        </t-form-item>
      </t-form>
      <div class="calc-rules-rate">
        <h4>基准计算规则 </h4><span class="calc-rules-rate-danwei">费率：%</span>
        <t-table bordered row-key="index" :data="data" :columns="columns" />
      </div>
      <div style="height: 20px;"></div>
    </div>
    <help v-bind:visible.sync="helpOpen"></help>
  </div>
</template>

<script>
import { bidCalculate } from '@/api/data'
//服务招标-设计招标代理（已废）
export default {
  name: 'designTender',
  components: {

  },
  data() {
    return {
      downLoading:false,
      validateMessage: {
        projectName: [
    {
      type: 'error',
      message: '项目名称不能为空',
    },
  ],
  money: [
    {
      type: 'error',
      message: '请输入规范数字',
    },
  ]

},
      rules: {
        projectName:[{ required: true },  {  type: 'warning' }],
        money:[{ required: true },{ pattern: /^[0-9.]*$/,message:'请输入规范数字',required: true,type: 'warning' }],
        domainCoefficient:[{ required: true },{ pattern: /^[0-9.]*$/,message:'请输入规范数字',required: true,type: 'warning' }],
        complexityCoefficient:[{ required: true },{ pattern: /^[0-9.]*$/,message:'请输入规范数字',required: true,type: 'warning' }],
        elevationCoefficient:[{ required: true },{ pattern: /^[0-9.]*$/,message:'请输入规范数字',required: true,type: 'warning' }],
        otherDesign:[{ required: true },{ pattern: /^[0-9.]*$/,message:'请输入规范数字',required: true,type: 'warning' }]
      }, 
      helpOpen:false,
      discountRate: null,
      downData:{},//下载时传值
      formData: {
        projectName: '',
        money: null,
        subtotal: null,
        discountRate: 0,
        discountRateMoney: null,
        result: null,
        remark: 3
      },
      resultChinese: '',
      fileList: [],
      data: [{
        id: 1,
        name: '投资估算编制或审核',
        radix: '估算价',
        firstRate: '1.50',
        secondRate: '0.80',
        thirdRate: '0.45',
        fourthRate: '0.25',
        fifthRate: '0.10',
        sexthRate: '0.05',
        seventhRate: '0.01'
      }],
      
      columns: [
        {
          title: '序',
          colKey: 'id',
          width: 90,
        },
        {
          title: '咨询项目',
          colKey: 'name',
          width: 180,
        },
        {
          title: '收费基数',
          colKey: 'radix',
          width: 110,
        },
        {
          title: '分档累进计费标准',
          width: 100,
          colKey: '-',
          children: [
            {
              colKey: 'firstRate',
              title: '100万以内',
              width: 100,
            },
            {
              title: '101万-\n500万',
              colKey: 'secondRate',
              width: 100,
            },
            {
              title: '501万-\n1000万',
              colKey: 'thirdRate',
              width: 100,
            },
            {
              title: '1001万-\n5000万',
              colKey: 'fourthRate',
              width: 100,
            },
            {
              title: '5001万-\n10000万',
              colKey: 'fifthRate',
              width: 100,
            },
            {
              title: '10001万-\n100000万',
              colKey: 'sexthRate',
              width: 100,
            },
            {
              title: '100001\n万以上',
              colKey: 'seventhRate',
              width: 100,
            }
          ],
        },

      ]
      
    }
  },
  methods: {
    onReset() {
      this.$message.success('重置成功');
      console.log('formData', this.formData);
    },
    onSubmit({ validateResult, firstError }) {
     if (validateResult === true) {
        this.submit()
        this.$message.success('提交成功');
      } else {
        console.log('Errors: ', validateResult);
        this.$message.warning(firstError);
      }
    },
    downLoad(){
      this.downLoading = true
      this.download('/project/bid/excle', {id:this.downData.id}
      , `设计招标代理收费计算.xlsx`).then(res => {
console.log(res)
this.downLoading = false
      }
      )
    },
    handleClear() {
      this.helpOpen = true
    },
    submit() {
      this.formData.discountRate = Number(this.discountRate) / 100
      bidCalculate(this.formData).then(res => {
        this.downData = res.data
         this.formData.money = res.data.money.toString()
        this.formData.discountRateMoney = res.data.discountRateMoney.toFixed(2).toString()
        this.formData.result = res.data.result.toFixed(2).toString()
        this.formData.subtotal = res.data.subtotal.toFixed(2).toString()
        // this.formData.money.toString()
        this.resultChinese = this.changeNumMoneyToChinese(Number(this.formData.result))
      })
    },
    resultChange(value) {
      this.resultChinese = this.changeNumMoneyToChinese(value)
    }
  },
}
</script>

<style lang="less" >
.tender-agency {
  background: #ffffff;
  width: 1168px;
  margin: 0 auto;



}</style>
